import React from "react";

// Minimal, safe markdown renderer for our generated content subset:
// ## / ### headings, **bold**, > blockquote, - lists, 1. ordered, tables, paragraphs.
function inline(text) {
  const parts = [];
  const re = /\*\*(.+?)\*\*|\[(.+?)\]\((.+?)\)/g;
  let last = 0, m, k = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1]) parts.push(<strong key={k++}>{m[1]}</strong>);
    else parts.push(<a key={k++} href={m[3]}>{m[2]}</a>);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export function Markdown({ source }) {
  if (!source) return null;
  const lines = source.split("\n");
  const out = [];
  let i = 0, key = 0;
  while (i < lines.length) {
    let line = lines[i];
    if (!line.trim()) { i++; continue; }
    if (line.startsWith("## ")) { out.push(<h2 key={key++}>{inline(line.slice(3))}</h2>); i++; continue; }
    if (line.startsWith("### ")) { out.push(<h3 key={key++}>{inline(line.slice(4))}</h3>); i++; continue; }
    if (line.startsWith("> ")) {
      const buf = [];
      while (i < lines.length && lines[i].startsWith("> ")) { buf.push(lines[i].slice(2)); i++; }
      out.push(<blockquote key={key++}>{inline(buf.join(" "))}</blockquote>); continue;
    }
    if (line.startsWith("|")) {
      const rows = [];
      while (i < lines.length && lines[i].startsWith("|")) { rows.push(lines[i]); i++; }
      const cells = (r) => r.split("|").slice(1, -1).map((c) => c.trim());
      const header = cells(rows[0]);
      const body = rows.slice(2).map(cells);
      out.push(
        <div key={key++} className="overflow-x-auto">
          <table><thead><tr>{header.map((h, x) => <th key={x} scope="col">{h}</th>)}</tr></thead>
          <tbody>{body.map((r, y) => <tr key={y}>{r.map((c, x) => <td key={x}>{inline(c)}</td>)}</tr>)}</tbody></table>
        </div>);
      continue;
    }
    if (/^\d+\.\s/.test(line)) {
      const buf = [];
      while (i < lines.length && /^\d+\.\s/.test(lines[i])) { buf.push(lines[i].replace(/^\d+\.\s/, "")); i++; }
      out.push(<ol key={key++}>{buf.map((b, x) => <li key={x}>{inline(b)}</li>)}</ol>); continue;
    }
    if (line.startsWith("- ")) {
      const buf = [];
      while (i < lines.length && lines[i].startsWith("- ")) { buf.push(lines[i].slice(2)); i++; }
      out.push(<ul key={key++}>{buf.map((b, x) => <li key={x}>{inline(b)}</li>)}</ul>); continue;
    }
    out.push(<p key={key++}>{inline(line)}</p>); i++;
  }
  return <div className="prose-bc">{out}</div>;
}
